import React, { useMemo } from 'react';

export interface StepComponentProps {
  onContinue?: () => void;
}

export interface StepContent {
  step: number;
  content: React.ReactNode;
  stepName?: string;
}

interface StepsFormProps {
  data: StepContent[];
  currentStep: number;
}

const StepsForm: React.FC<StepsFormProps> = ({ data, currentStep }) => {
  const currentStepInfos = useMemo(() => {
    return data[data.findIndex((step) => step.step === currentStep)];
  }, [currentStep, data]);

  return <>{currentStepInfos?.content}</>;
};

export default StepsForm;
